module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_header_hairstyle-70426d60cbacc25a70a8c6eb996a5ca8.svg";